import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "../../Button/index.js";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { s } from "../../../style.module-B2VZNtqv.js";
const Multiline = forwardRef(
  ({
    className,
    children: textAreaRenderFunction,
    onClear,
    footerClassName,
    textAreaClassName,
    maxLength,
    value = "",
    onChange,
    onBlur,
    clearText,
    placeholder,
    thresholdToShowCharCount = -1,
    ...rest
  }, ref) => {
    const charCount = value.length || 0;
    return /* @__PURE__ */ jsxs("section", { ...rest, className: clsx(s.textAreaContainer, className), ref, children: [
      textAreaRenderFunction == null ? void 0 : textAreaRenderFunction({
        value,
        onChange,
        onBlur,
        placeholder,
        maxLength,
        theme: "light",
        className: clsx(s.modalTextArea, textAreaClassName),
        resizeHeightOnOverflow: true
      }),
      (onClear || Boolean(maxLength)) && /* @__PURE__ */ jsxs("footer", { className: clsx(s.criticalSectionMultiline, footerClassName), children: [
        onClear && /* @__PURE__ */ jsx(
          Button,
          {
            className: s.clearButton,
            inline: true,
            intent: "critical",
            theme: "light",
            icon: /* @__PURE__ */ jsx(Icons24, { name: "Remove" }),
            onClick: onClear,
            children: clearText
          }
        ),
        Boolean(maxLength) && charCount > thresholdToShowCharCount && /* @__PURE__ */ jsxs("span", { className: s.wordCount, children: [
          /* @__PURE__ */ jsx("span", { children: charCount }),
          /* @__PURE__ */ jsx("span", { children: "/" }),
          /* @__PURE__ */ jsx("span", { children: maxLength })
        ] })
      ] })
    ] });
  }
);
Multiline.displayName = "Modal.InputFields.Multiline";
export {
  Multiline
};
